import React from "react";
import Utils from "../utils/utils";
import AccessCodesStore from "../stores/access-codes-store";
import Dispatcher from "../dispatcher";
import ResourceAction from "../actions/resource-action";
import { VstLoader } from "vstui";

class AccessCodes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resources: AccessCodesStore.getAll(),
    };
  }

  // Force update of assets
  _getUpdatedState = () => {
    this.setState({
      resources: AccessCodesStore.getAll(true),
    });
  }

  componentDidMount() {
    Dispatcher.on(
      Dispatcher.ACCESS_CODE_STORE_CHANGE,
      this._handleResourceChange
    );
  }

  componentWillUnmount() {
    Dispatcher.removeListener(
      Dispatcher.ACCESS_CODE_STORE_CHANGE,
      this._handleResourceChange
    );
  }

  _handleResourceChange = () => {
    this.setState({ resources: AccessCodesStore.getAll(true) });
  }

  _revealCode = (e) => {
    let code = e.currentTarget.getAttribute("data-id");

    ResourceAction.redeemAccessCode(code);
  }

  _copyCode = (e) => {
    // Select input field and fire copy command
    let prev = e.currentTarget.previousSibling;
    prev.select();
    try {
      let successful = document.execCommand("copy");
      let msg = successful ? "successful" : "unsuccessful";
    } catch (err) {
      alert(i18n.t("resources.copy-fail"));
    }
  }

  render() {
    let resources = this.state.resources ? this.state.resources.licenses : [];
    let accessCodes = [];
    // Filter through data to display all ancillaries with book covers/authors/etc.
    resources.forEach((value, key) => {
      let anc = value.ancillaries || [];
      if (anc.length > 0) {
        // Select last accesscode from object
        let lastAccessCode = anc[anc.length - 1];
        // Add book info to each access code
        lastAccessCode.author = value.author;
        lastAccessCode.title = value.title;
        lastAccessCode.coverURL = value.coverURL;
        lastAccessCode.isbn = value.isbn;
        accessCodes.push(lastAccessCode);
      }
    });

    if (accessCodes.length > 0) {
      accessCodes = (
        <div className="deck resource-list">
          {accessCodes.map((item, index) => {
            let href, linkText;
            if (item.href) {
              href = item.href;
              linkText = i18n.t("resources.launch-site");
            } else {
              href =
                "https:" + Mulligan.Brand.endpoint + "/#/books/" + item.isbn;
              linkText = i18n.t("resources.launch-book");
            }
            return (
              <div className="clear card" key={index}>
                <div className="left">
                  <img className="cover" src={item.coverURL} alt="" />
                  <div className="details">
                    <strong className="title">
                      {Utils.toHTML(item.title)}
                    </strong>
                    <span className="author">{item.author}</span>
                    <span className="expiration">
                      {i18n.t("resources.expiration-message")}
                    </span>
                  </div>
                </div>
                <div className="right access-code-width">
                  {item.revealed && (
                    <div className="access-code-container">
                      <input value={item.accessCode} readOnly="true"></input>
                      <a
                        className="vst-href-to-button copy-button"
                        onClick={this._copyCode}
                      >
                        {i18n.t("base.copy")}
                      </a>
                      <a href={href} target="_blank">
                        {linkText}
                      </a>
                    </div>
                  )}
                  {!item.revealed && (
                    <div className="access-code-container">
                      <a
                        className="vst-href-to-button"
                        onClick={this._revealCode}
                        data-id={item.isbn}
                      >
                        {i18n.t("resources.reveal-code")}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      );
    } else if (this.state.resources === undefined) {
      accessCodes = (
        <div className="deck resource-list">
          <VstLoader />
        </div>
      );
    } else {
      accessCodes = <p>{i18n.t("resources.no-access-codes")}</p>;
    }

    return <div>{accessCodes}</div>;
  }
}

export default AccessCodes;
